import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, first, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root',
})
export class HttpAuthInterceptorService implements HttpInterceptor {
    private auth = inject(AuthService);

    private whiteList: string[];
    private apiUrl: string;

    constructor() {
        this.whiteList = [
            environment.translations.app,
            environment.translations.dsw,
            environment.statusPage,
            'saml/csrf',
        ];
        this.apiUrl = new URL(environment.apiUrl).host;
    }

    intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (!req.url.includes(this.apiUrl) || this.whiteList.some((url) => req.url.includes(url))) {
            return next.handle(req);
        }

        return this.auth.csrfToken$.pipe(
            first((val) => val !== undefined),
            switchMap((value) =>
                next.handle(req.clone({ headers: req.headers.set('Authorization', `CSRF ${value}`) })).pipe(
                    catchError((e) => {
                        if (e instanceof HttpErrorResponse && e.status === 401) {
                            // refresh CSRF token and retry active request if fetching of token succeed
                            return this.auth.fetchNewCsrfToken().pipe(switchMap(() => this.intercept(req, next)));
                        }
                        throw e;
                    }),
                ),
            ),
        );
    }
}
